import FrontPage from "./FrontPage";
import { Routes, Route } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import React, { useEffect, useState, useCallback } from "react";
import NewTicket from "./NavbarItems/ListOfTickets/NewTicket";
import { Header } from "./Header";
import Navbar from "./Navbar";
import TicketDetails from "./NavbarItems/ListOfTickets/TicketDetails";
import Login from "./Login";
import { UseTicket, SetTicket } from "../Js/Context/TicketCntx";
import { CallService, signOut, modalAlert } from "../Js/Script";
import { SetDepartment, UseDepartment } from "../Js/Context/DepartmentCntx";
import { SetCategory, UseCategory } from "../Js/Context/CategoryCntx ";
import { UseOrganizaton, SetOrganizaton } from "../Js/Context/OrganizationCntx";
import { SetUser, UseUser } from "../Js/Context/userCntx";
import {UseSearch} from "../Js/Context/SearchCntx"


export default function Main() {
  const stSearch = UseSearch();
  //console.log("main stSearch=",stSearch);
  const stDepartments = UseDepartment();
  const setStDepartments = SetDepartment();
  const stCategory = UseCategory();
  const SetStCategory = SetCategory();
  const stOrganization = UseOrganizaton();
  const setStOrganizaton = SetOrganizaton();
  const stUser = UseUser();
  const setStUser = SetUser();
  const ticket = UseTicket();
  const setTicket = SetTicket();
  const navigate = useNavigate();
  const Ticket = localStorage.getItem("Ticket");
  useEffect(() => {
    setTicket((prev) => ({
      ...prev,
      ContractSide: "tickets",
      SearchTickets: "",
      NavbarItem: "",
    }));
  }, []);

  useEffect(() => {
    if (!Ticket) {
      navigate(`${process.env.PUBLIC_URL}/Login`);
    } else {
      navigate(`${process.env.PUBLIC_URL}/FrontPage`, {
        state: {
          SearchTickets: ticket.SearchTickets,
          NavbarItem: ticket.NavbarItem,
        },
      });
    }
  }, [ticket.NavbarItem, ticket.SearchTickets]);

  const setSearchTickets = useCallback((searchTickets) => {
    setTicket((prevState) => ({
      ...prevState,
      SearchTickets: searchTickets,
    }));
  }, []);

  const setNavbarItemChoosed = useCallback((item) => {
    setTicket((prevState) => ({
      ...prevState,
      NavbarItem: item,
      SearchTickets: "",
    }));
  }, []);

  return (
    <div id="Main">
      <Header
        setSearchTickets={setSearchTickets}
        navbarItem={ticket.NavbarItem}
        ticket={Ticket ? true : false}
      />
      {Ticket && <Navbar setNavbarItemChoosed={setNavbarItemChoosed} />}

      <Routes>
        <Route
          path={`${process.env.PUBLIC_URL}/FrontPage`}
          element={<FrontPage />}
        />
        <Route path={`${process.env.PUBLIC_URL}/Login`} element={<Login />} />
        <Route
          path={`${process.env.PUBLIC_URL}/NewTicket`}
          element={<NewTicket />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/TicketDetails/:id`}
          element={<TicketDetails />}
        />
        <Route
          path={`${process.env.PUBLIC_URL}/TicketDetails`}
          element={<TicketDetails />}
        />
      </Routes>
    </div>
  );
}
